import { Collapse, Space } from 'antd';
import CloseButton from '../../../components/shared-components/CloseButton';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { API } from 'aws-amplify';
import { GenerateGameSessionTokenMutation, GetLatestWinnersQuery } from '../../../API';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import * as subscriptions from '../../../graphql/subscriptions';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { PlayerMode, selectPlayer } from '../../../features/player/playerSlice';
import { selectTheme, showLoading, ThemeColor } from '../../../features/theme/themeSlice';
import { generateGameSessionToken } from '../../../graphql/mutations';
import lang from '../../../fakedata/language.json';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

type SiderContentProps = {
	onClose: () => void;
};

type Evento = {
	id: string;
	hour: string;
	name: string;
};

const { Panel } = Collapse;

let t: any | null, t1: any | null;

const eventiPGVirtual = ['Horses', 'Dogs', 'Harness'];
const eventi3DSport = ['Dogs', 'Horses', 'Soccer', 'Basket', 'Tennis', 'Baseball'];

// const sports = ['galoppo', 'trotto', 'levrieri'];
// const eventiDogs = ['6 Runners Track', '8 Runners Track'];

// const eventiSoccer = [
// 	{ name: 'Juventus - Spezia', hour: '20:45' },
// 	{ name: 'Napoli - Lecce', hour: '20:45' },
// 	{ name: 'Liverpool - Newcastle', hour: '15:00' },
// 	{ name: 'Sampdoria - Lazio', hour: '15:00' },
// 	{ name: 'Tolosa - Psg', hour: '20:45' },
// 	{ name: 'Arsenal - Aston Villa', hour: '12:30' },
// 	{ name: 'Empoli - Verona', hour: '15:00' },
// 	{ name: 'Ascoli - Cittadella', hour: '20:45' },
// 	{ name: 'Verona - Sampdoria', hour: '15:00' },
// 	{ name: 'Salernitana - Empoli', hour: '18:30' },
// 	{ name: 'Everton - Liverpool', hour: '13:30' },

// 	{
// 		name: 'Brentford - Leeds',
// 		hour: '16:00'
// 	},
// 	{
// 		name: 'Chelsea - West Ham',
// 		hour: '16:00'
// 	},
// 	{ name: 'Newcastle - Crystal Palace', hour: '16.00' }
// ];

// const eventiHorse = [
// 	'Vincennes1',
// 	'Southwell Racecourse6',
// 	'Varese',
// 	'Vincennes2',
// 	'Southwell Racecourse3',
// 	'Lingfield Park3',
// 	'Lingfield Park5',
// 	'Wolverhampton5',
// 	'Wolverhampton3',
// 	'Varese Gl/pm5'
// ];

const getLatestWinners = /* GraphQL */ `
	query GetLatestWinners($limit: Int, $dal: Int!, $al: Int!) {
		getLatestWinners(limit: $limit, dal: $dal, al: $al) {
			amount
			username
			amountWinning
			valute
		}
	}
`;

let minutes = 0;
let nEvent = 0;

const SiderContent = ({ onClose }: SiderContentProps) => {
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const player = useAppSelector(selectPlayer);
	const theme = useAppSelector(selectTheme);
	const [eventsDogs, setEventsDogs] = useState<Evento[]>([]);
	const [eventsHarness, setEventsHarness] = useState<Evento[]>([]);
	const [eventsSoccer, setEventsSoccer] = useState<Evento[]>([]);
	const [eventsHorse, setEventsHorse] = useState<Evento[]>([]);
	const languages = lang.filter(l => l.langId == theme.language);
	const dispatch = useDispatch();
	const [closeAll, setCloseAll] = useState<boolean>(true);
	const [collapseTab, setCollapseTab] = useState<Array<number>>([1, 0]);
	const intl = useIntl();
	const navigate = useNavigate();
	const [latestWinners, setLatestWinners] = useState<
		Array<{ username: string; amount: number; amountWinning: number; valute: string }>
	>([]);

	let s: any = null;

	const playEvent = () => {
		dispatch(showLoading(true));
		// (async () => {
		// 	try {
		// 		const result: GraphQLResult<GenerateGameSessionTokenMutation> = (await API.graphql({
		// 			query: generateGameSessionToken,
		// 			authMode: player.logged ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS : GRAPHQL_AUTH_MODE.AWS_IAM,
		// 			variables: {
		// 				currency: player.account.valute,
		// 				lang: languages[0].langCode
		// 			}
		// 		})) as GraphQLResult<GenerateGameSessionTokenMutation>;
		// 		//console.log(result);
		// 		dispatch(showLoading(false));

		// 		navigate(`/playpgvirtual/` + result.data.generateGameSessionToken);
		// 	} catch (e) {
		// 		console.log(e);
		// 	}
		// })();
		navigate('/playpgvirtual');
	};

	useEffect(() => {
		const dal = moment().subtract(30, 'days').unix();
		const al = moment().unix();

		t = setInterval(() => {
			const e = [];
			nEvent = 0;
			for (let i = 0; i < 14; i++) {
				minutes += 6;
				const s: string = eventiPGVirtual[nEvent++];
				e.push({
					id: `${Math.random().toString().slice(2, 6)}`,
					hour: moment().add(minutes, 'minute').format('HH:mm'),
					name: s
				});
				nEvent = nEvent > 2 ? 0 : nEvent;
			}
			setEventsDogs(e);
		}, 300000);
		minutes = 0;
		t1 = setInterval(() => {
			const e = [];
			nEvent = 0;
			for (let i = 0; i < 14; i++) {
				minutes += 3;
				const s: string = eventi3DSport[nEvent++];

				e.push({
					id: `${Math.random().toString().slice(2, 5)}`,
					hour: moment().add(minutes, 'minute').format('HH:mm'),
					name: s
				});
				nEvent = nEvent > 5 ? 0 : nEvent;
			}
			setEventsHorse(e);
		}, 420000);

		// (async () => {
		// 	try {
		// 		const result: GraphQLResult<GetLatestWinnersQuery> = (await API.graphql({
		// 			query: getLatestWinners,
		// 			authMode: player.logged ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS : GRAPHQL_AUTH_MODE.AWS_IAM,
		// 			variables: { dal: dal, al: al }
		// 		})) as GraphQLResult<GetLatestWinnersQuery>;

		// 		const orderedResult = result.data.getLatestWinners.sort((a, b) => b.amountWinning - a.amountWinning);

		// 		setLatestWinners(Object.assign(orderedResult.slice(0, 15)));
		// 	} catch (e) {
		// 		console.error('error load latest winner');
		// 		dispatch(showLoading(false));
		// 	}
		// })();

		const eDogs = [];

		nEvent = 0;
		for (let i = 0; i < 14; i++) {
			minutes += 6;
			const s: string = eventiPGVirtual[nEvent++];
			eDogs.push({
				id: `${Math.random().toString().slice(2, 5)}`,
				hour: moment().add(minutes, 'minute').format('HH:mm'),
				name: s
			});
			nEvent = nEvent > 2 ? 0 : nEvent;
		}
		setEventsDogs(eDogs);

		minutes = 2;
		const eHorse = [];
		nEvent = 0;
		for (let i = 0; i < 14; i++) {
			minutes += 6;
			const s: string = eventi3DSport[nEvent++];

			eHorse.push({
				id: `${Math.random().toString().slice(2, 5)}`,
				hour: moment().add(minutes, 'minute').format('HH:mm'),
				name: s
			});
			nEvent = nEvent > 5 ? 0 : nEvent;
		}
		setEventsHorse(eHorse);

		return () => {
			clearInterval(t);
			if (s) {
				s.unsubscribe();
			}
		};
	}, []);

	return (
		<div className="sidebar">
			<CloseButton
				onClose={() => {
					onClose();
				}}
			/>
			<Space direction="vertical" style={{ width: '100%', marginBottom: '2px' }}>
				<div className="title-panel" >
					<div>{intl.formatMessage({ id: 'departing.events' })}</div>
					{/* <div
						className="pointer"
						style={{ position: 'absolute', top: '0', right: '15px' }}
						onClick={() => setCloseAll(!closeAll)}
					>
						{!closeAll && <FontAwesomeIcon icon={faPlus} />}
						{closeAll && <FontAwesomeIcon icon={faMinus} />}
					</div> */}
				</div>
			</Space>
			<Space direction="vertical" style={{ width: '100%' }}>
				<Collapse
					className="collapse-event collapse-event-table"
					defaultActiveKey={1}
					expandIconPosition="right"
					ghost
				>
					<Panel
						className="collapse-event-panel collapse-event-panel-table"
						header={intl.formatMessage({ id: 'PGVirtual' })}
						key={1}
					>
						<div className={`d-table ${theme.theme === ThemeColor.dark ? 'dark' : ''}`}>
							<table>
								<thead>
									<tr>
										<th>
											<FormattedMessage id="code" />
										</th>
										<th>
											<FormattedMessage id="hour" />
										</th>
										<th>
											<FormattedMessage id="event" />
										</th>
									</tr>
								</thead>
								<tbody>
									{eventsDogs.map((e, i) => {
										return (
											<tr key={i}>
												<td className="text-center">{e.id}</td>
												<td className="text-center">{e.hour}</td>
												<td className="text-center">
													<div
														className="pointer"
														onClick={() => {
															playEvent();
														}}
													>
														{e.name}
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</Panel>
				</Collapse>
			</Space>
			<Space direction="vertical" style={{ width: '100%' }}>
				<Collapse
					className="collapse-event collapse-event-table"
					expandIconPosition="right"
					ghost
					defaultActiveKey={2}
				>
					<Panel className="collapse-event-panel" header={intl.formatMessage({ id: '3D Sport' })} key={2}>
						<div className={`d-table ${theme.theme === ThemeColor.dark ? 'dark' : ''}`}>
							<table>
								<thead>
									<tr>
										<th>
											<FormattedMessage id="code" />
										</th>
										<th>
											<FormattedMessage id="hour" />
										</th>
										<th>
											<FormattedMessage id="event" />
										</th>
									</tr>
								</thead>
								<tbody>
									{eventsHorse.map((e, i) => {
										return (
											<tr key={i}>
												<td className="text-center">{e.id}</td>
												<td className="text-center">{e.hour}</td>
												<td className="text-center">
													<div
														className="pointer"
														onClick={() => {
															alert('game not available!');
														}}
													>
														{e.name}
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</Panel>
				</Collapse>
			</Space>

			{/* {player.mode === PlayerMode.DEFAULT && (
				<Space direction="vertical" style={{ width: '100%' }}>
					<Collapse
						className="collapse-latest-winners collapse-event"
						defaultActiveKey={['1']}
						expandIconPosition="right"
						ghost
					>
						<Panel
							className="collapse-latest-winners-panel"
							header={intl.formatMessage({ id: 'highest.winnings.last.month' })}
							key={1}
						>
							<div className={`d-table ${theme.theme === ThemeColor.dark ? 'dark' : ''}`}>
								<table>
									<thead>
										<tr>
											<th>USERNAME</th>
											<th>
												<FormattedMessage id="amount" />
											</th>
											<th>
												<FormattedMessage id="win" />
											</th>
										</tr>
									</thead>
									<tbody>
										{latestWinners &&
											latestWinners.map((l, i) => {
												return (
													<tr key={`l-${i}`}>
														<td>{l.username}</td>
														<td className="text-center">
															<div className={`valute valute-${theme.language}`}>
																<FormattedNumber
																	value={l.amount}
																	style="currency"
																	currency={l.valute}
																/>
															</div>
														</td>
														<td className="text-center">
															<div className={`valute valute-${theme.language}`}>
																<FormattedNumber
																	value={l.amountWinning}
																	style="currency"
																	currency={l.valute}
																/>
															</div>
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							</div>
						</Panel>
					</Collapse>
				</Space>
			)} */}
		</div>
	);
};

export default SiderContent;
